import { Snackbar, Alert } from "@mui/material";
import React from "react";
import { IStatusSnackbarProps } from "../../../interfaces/Fleet/IStatusSnackbarProps";

const StatusSnackbar: React.FC<IStatusSnackbarProps> = ({
  status,
  successMessage,
  errorMessage,
  handleClose,
  sx,
  anchorOrigin,
}) => {
  const resolvedAnchorOrigin =
    anchorOrigin ?? { vertical: "top", horizontal: "center" };

  return (
    <>
      <Snackbar
        open={status === "success"}
        autoHideDuration={6000}
        onClose={handleClose}
        sx={sx}
        anchorOrigin={resolvedAnchorOrigin}
      >
        <Alert onClose={handleClose} severity="success">
          {successMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={status === "error"}
        autoHideDuration={6000}
        onClose={handleClose}
        sx={sx}
        anchorOrigin={resolvedAnchorOrigin}
      >
        <Alert onClose={handleClose} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default StatusSnackbar;
